export default {
    Get: {
        LIST_OF_PROPERTY_RELATIONS: 'getListOfPropertyRelations',
        PROPERTY_RELATION: 'propertyRelation',
        CURRENT_RELATION: 'getCurrentRelation',
    },
    Set: {
        LIST_OF_PROPERTY_RELATIONS: 'setListOfPropertyRelations',
        REODER_PROPERTY_RELATION: 'reOderPropertyRelation',
        ASSIGNVALUE_RELATION: 'setRelationValuePartial',
        ADD_TO_LIST: 'setRelationToList',
        CURRENT_RELATION: 'setCurrentRelation',
        RELATION_INDEXES: 'setRelationIndexes',
        DELETE_RELATION: 'deleteRelation',
    }
};